export const FlowTypes = {
  newBusiness: 'NEW_BUSINESS',
  unavailable: 'UNAVAILABLE',
  renewal: 'RENEWAL',
} as const;

export type FlowType = (typeof FlowTypes)[keyof typeof FlowTypes];
